<template>
  <div class="payment-page style2">
    <h2 class="table-title primary-text">
      Quý khách vui lòng chọn hợp đồng cần tính toán
    </h2>
    <div>
      <div
        class="loan-table hidden sm:hidden md:hidden lg:block"
      >
        <table class="table-auto">
          <thead>
          <tr>
            <th class="px-4 py-2"></th>
            <th class="px-4 py-2">
              Số hợp đồng
            </th>
            <th class="px-4 py-2">
              Biển số xe
            </th>
            <th class="px-4 py-2">
              Ngày hiệu lực<br />
              hợp đồng
            </th>
            <th class="px-4 py-2">
              Ngày kết thúc<br />
              hợp đồng
            </th>
            <th class="px-4 py-2">
              Số tiền vay <br />(VND)
            </th>
            <th class="px-4 py-2">
              Dư nợ <br />
              (VND)
            </th>
            <th class="px-4 py-2">
              Số tiền<br />
              cần thanh toán
            </th>
            <th class="px-4 py-2"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in earlyPayments" :key="index" >
            <td class="px-4 py-2">
              <div class="car-tag">
                {{item.Brand}}
              </div>
            </td>
            <td class="px-4 py-2">
              {{item.ContractNo}}
            </td>
            <td class="px-4 py-2">
              {{item.PlateNo}}
            </td>
            <td class="px-4 py-2" v-if="item.ContractDateStart && item.ContractDateStart !== null">
              {{ item.ContractDateStart | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
            </td>
            <td class="px-4 py-2" v-else>
            </td>
            <td class="px-4 py-2" v-if="item.ContractDateEnd && item.ContractDateEnd !== null">
              {{ item.ContractDateEnd | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
            </td>
            <td class="px-4 py-2" v-else>
            </td>
            <td class="px-4 py-2">
              {{Number(item.ContractAmount).toLocaleString()}}
            </td>
            <td class="px-4 py-2">
              {{Number(item.ContractAmountOutstanding).toLocaleString()}}
            </td>
            <td class="px-4 py-2">
              <span class="primary-value">
                {{Number(item.PaymentAmount).toLocaleString()}}
              </span>
            </td>
            <td class="px-4 py-2">
              <router-link  v-if="item.IsOverDue === false && item.IsLessThan6M === false && item.IsLessThan12M === false" class="primary-button" :to="{ name: 'earlyPaymentDetail', params: {contractNo: item.ContractNo}}">
                CHỌN
              </router-link>
              <button class="primary-button"  @click="openWarningModal(item)" v-else>
                CHỌN
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div
        class="loan-contract block sm:block md:block lg:hidden"
      >
        <ul class="contract-list">
          <li class="contract-item" v-for="(item, index) in earlyPayments" :key="index">
            <div class="car-tag">{{item.Brand}}</div>
            <p class="contract-text">
              Số hợp đồng
            </p>
            <p class="contract-number">
              {{item.ContractNo}}
            </p>
            <div class="flex flex-wrap">
              <div class="w-2/4">
                <p class="contract-text">
                  Biển số xe
                </p>
                <p class="contract-value">
                  {{item.PlateNo}}
                </p>
              </div>
              <div class="w-2/4">
                <p class="contract-text">
                  Bắt đầu hợp đồng
                </p>
                <p class="contract-value"  v-if="item.ContractDateStart && item.ContractDateStart !== null">
                  {{ item.ContractDateStart | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
                </p>
                <p class="contract-value"  v-else>
                </p>
              </div>
              <hr />
              <div class="w-2/4">
                <p class="contract-text">
                  Kết thúc hợp đồng
                </p>
                <p class="contract-value"  v-if="item.ContractDateEnd && item.ContractDateEnd !== null">
                  {{ item.ContractDateEnd | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
                </p>
                <p class="contract-value"  v-else>
                </p>
              </div>
              <div class="w-2/4">
                <p class="contract-text">
                  Số tiền vay (VND)
                </p>
                <p class="contract-value">
                  {{Number(item.ContractAmount).toLocaleString()}}
                </p>
              </div>
              <hr />
              <div class="w-2/4">
                <p class="contract-text">
                  Dư nợ (VND)
                </p>
                <p class="contract-value">
                  {{Number(item.ContractAmountOutstanding).toLocaleString()}}
                </p>
              </div>
              <div class="w-2/4">
                <p class="contract-text">
                  Số tiền cần thanh toán
                </p>
                <p class="contract-value">
                  <span class="primary-value">{{Number(item.PaymentAmount).toLocaleString()}}</span>
                </p>
              </div>
              <div class="w-full">
                <router-link  v-if="item.IsOverDue === false && item.IsLessThan6M === false && item.IsLessThan12M === false" class="primary-button" :to="{ name: 'earlyPaymentDetail', params: {contractNo: item.ContractNo}}">
                  CHỌN
                </router-link>
                <button class="primary-button"  @click="openWarningModal(item)" v-else>
                  CHỌN
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <paginate
        :pageCount="pageCount"
        :containerClass="'pagination'"
        :prev-text="'<i class=&quot;iconvl icon-angle-left&quot;></i>'"
        :next-text="'<i class=&quot;iconvl icon-angle-right&quot;></i>'"
        :clickHandler="paginateCallback">
      </paginate>
    </div>
    <UiModal closeOnOverlay :show.sync="isShownModal">
    <div
        class="modal-scroll bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50"
      >
      <div class="update-email-form-modal" style="max-width: 792px">
        <div class="update-email-form-modal-close" @click="isShownModal = false"><img src="@/assets/img/icon-close.svg" alt="Close" /></div>
        <!--Body-->
        <div class="modal-content">
          <div class="modal-body">
            <p><center><b>Thông báo</b></center></p>
            <br>
            <p v-html="warningMessage"></p>
          </div>
        </div>
        <!--Footer-->
        <div class="modal-footer" style="display: flex;">
          <button class="modal-close px-4 p-3" @click="isShownModal = false">
            OK
          </button>
        </div>
      </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'

import Paginate from 'vuejs-paginate'
import UiModal from '@/components/UiModal.vue'
import moment from 'moment'

export default {
  name: 'EarlyPaymentList',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  props: {
    limit: { type: Number },
    page: { type: Number }
  },
  components: {
    Paginate,
    UiModal
  },
  data () {
    return {
      isShownModal: false,
      warningMessage: ''
    }
  },
  watch: {
    'pagination.limit': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      this.fetchData()
    },
    'pagination.page': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      this.fetchData()
    },
    limit: {
      handler: function (newVal) {
        this.$store.commit('earlyPayments/SET_PAGINATION', { limit: newVal })
      },
      immediate: true
    },
    page: {
      handler: function (newVal) {
        this.$store.commit('earlyPayments/SET_PAGINATION', { page: newVal })
      },
      immediate: true
    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('earlyPayments/getListPublic', { params: this.fetchParams })
    },
    paginateCallback: function (page) {
      this.pagination.page = page
      this.fetchData()
    },
    submitModalHandler () {
      this.isShownModal = false
    },
    openWarningModal (item) {
      this.isShownModal = true
      if (item.IsOverDue === true) {
        this.warningMessage = 'Quý khách vui lòng liên hệ <strong>028-73090998</strong> để trao đổi chi tiết về khoản tiền trả sớm.Trân trọng!'
        return
      }

      if (item.IsLessThan6M === true || item.IsLessThan12M === true) {
        this.warningMessage = `Quý khách chỉ có thể thanh lý hợp đồng từ ngày ${moment(String(item.DateValid)).format('DD/MM/YYYY')}. Trân trọng!`
      }
    }
  },
  computed: {
    ...mapState('earlyPayments', {
      earlyPayments: 'items',
      pagination: 'pagination',
      error: 'error',
      loading: 'loading'
    }),
    ...mapGetters('earlyPayments', [
      'isEmpty'
    ]),
    useInUrlQueryPropList () {
      return this.prepareQueryParamsMixin({
        limit: this.pagination.limit,
        page: this.pagination.page
      })
    },
    fetchParams () {
      const pagination = this.prepareFetchParamsMixin({
        limit: this.pagination.limit,
        pageIndex: this.pagination.page
      })

      return { ...pagination }
    },
    pageCount () {
      return Math.ceil(this.pagination.total / this.pagination.limit)
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
